"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.update = void 0;
const tslib_1 = require("tslib");
const constants_1 = require("../constants");
const types_1 = require("../types");
const helpers_1 = require("./../chat/helpers");
const updateGroup_1 = require("../chat/updateGroup");
const get_1 = require("./get");
const update = options => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
  const {
    spaceId,
    spaceName,
    spaceImage,
    spaceDescription,
    listeners,
    speakers,
    signer,
    env = constants_1.default.ENV.PROD,
    pgpPrivateKey = null,
    scheduleAt,
    scheduleEnd,
    status
  } = options || {};
  try {
    const space = yield (0, get_1.get)({
      spaceId,
      env
    });
    if (space.status === types_1.ChatStatus.ACTIVE && scheduleAt) {
      throw new Error('Unable change the start date/time of an active space');
    }
    if (space.status === types_1.ChatStatus.ENDED && scheduleEnd) {
      throw new Error('Unable change the end date/time of an ended space');
    }
    const group = yield (0, updateGroup_1.updateGroup)({
      chatId: spaceId,
      groupName: spaceName,
      groupImage: spaceImage,
      groupDescription: spaceDescription,
      members: listeners,
      admins: speakers,
      signer: signer,
      env: env,
      pgpPrivateKey: pgpPrivateKey,
      scheduleAt: scheduleAt,
      scheduleEnd: scheduleEnd,
      status: status
    });
    return (0, helpers_1.groupDtoToSpaceDto)(group);
  } catch (err) {
    console.error("[Push SDK] - API  - Error - API ".concat(exports.update.name, " -:  "), err);
    throw Error("[Push SDK] - API  - Error - API ".concat(exports.update.name, " -: ").concat(err));
  }
});
exports.update = update;
//# sourceMappingURL=update_out.js.map